var map = {
	"./FaceTecStrings.af.js": [
		2726,
		"src_assets_core-sdk-optional_FaceTecStrings_af_js"
	],
	"./FaceTecStrings.ar.js": [
		4827,
		"src_assets_core-sdk-optional_FaceTecStrings_ar_js"
	],
	"./FaceTecStrings.de.js": [
		4051,
		"src_assets_core-sdk-optional_FaceTecStrings_de_js"
	],
	"./FaceTecStrings.el.js": [
		2305,
		"src_assets_core-sdk-optional_FaceTecStrings_el_js"
	],
	"./FaceTecStrings.en.js": [
		686,
		"src_assets_core-sdk-optional_FaceTecStrings_en_js"
	],
	"./FaceTecStrings.es.js": [
		6523,
		"src_assets_core-sdk-optional_FaceTecStrings_es_js"
	],
	"./FaceTecStrings.fr.js": [
		8394,
		"src_assets_core-sdk-optional_FaceTecStrings_fr_js"
	],
	"./FaceTecStrings.kk.js": [
		5637,
		"src_assets_core-sdk-optional_FaceTecStrings_kk_js"
	],
	"./FaceTecStrings.no.js": [
		5671,
		"src_assets_core-sdk-optional_FaceTecStrings_no_js"
	],
	"./FaceTecStrings.pt-br.js": [
		8876,
		"src_assets_core-sdk-optional_FaceTecStrings_pt-br_js"
	],
	"./FaceTecStrings.pt.js": [
		8957,
		"src_assets_core-sdk-optional_FaceTecStrings_pt_js"
	],
	"./FaceTecStrings.ru.js": [
		429,
		"src_assets_core-sdk-optional_FaceTecStrings_ru_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4879;
module.exports = webpackAsyncContext;